import { Fragment } from "react";
import { BedRequiredNotification } from "./BedRequiredNotification";
import { DeleteSuccessfulNotification } from "./DeleteSuccessfulNotification";
import { DeleteUnsuccessfulNotification } from "./DeleteUnsuccessfulNotification";
import { RequirementNotMetNotification } from "./RequirementNotMetNotification";
import { UnableToSaveNotification } from "./UnableToSaveNotification";
import { UploadUnsuccessfulNotification } from "./UploadUnsuccessfulNotification";
import { NotificationType } from "./constants";
import { useNotificationHandler } from "./useNotificationHandler";

export const Notifications = () => {
    const { notificationHandler } = useNotificationHandler();

    return (
        <Fragment>
            <BedRequiredNotification {...notificationHandler(NotificationType.BedRequired)} />
            <UnableToSaveNotification {...notificationHandler(NotificationType.UnableToSave)} />
            <RequirementNotMetNotification {...notificationHandler(NotificationType.RequirementNotMet)} />
            <UploadUnsuccessfulNotification {...notificationHandler(NotificationType.UploadFailed)} />
            <DeleteUnsuccessfulNotification {...notificationHandler(NotificationType.DeleteFailed)} />
            <DeleteSuccessfulNotification {...notificationHandler(NotificationType.DeleteSuccess)} />
        </Fragment>
    );
};
